(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tender-first-year"] && !Shopify.designMode) return;
  try {
    
function initialiseTenderForms(){
  document.querySelectorAll('[data-tc-product]').forEach(root=>{
    if(root.dataset.ready)return;
    root.dataset.ready='true';

    const form=root.querySelector('form');
    const inputs=[...root.querySelectorAll('[data-tc-photo]')];
    const error=root.querySelector('[data-tc-error]');
    const button=root.querySelector('button[type=submit]');
    const progress=root.querySelector('[data-tc-progress]');
    const allowedTypes=['image/jpeg','image/png','image/webp'];
    const targetBytes=600*1024;
    const maxTotalBytes=8*1024*1024;
    const maxDimension=2000;

    const showError=message=>{
      error.textContent=message;
      error.hidden=false;
      error.scrollIntoView({block:'center'});
    };

    const loadImage=file=>new Promise((resolve,reject)=>{
      const url=URL.createObjectURL(file);
      const image=new Image();
      image.onload=()=>{
        URL.revokeObjectURL(url);
        resolve(image);
      };
      image.onerror=()=>{
        URL.revokeObjectURL(url);
        reject(new Error('image_decode_failed'));
      };
      image.src=url;
    });

    const canvasBlob=(canvas,quality)=>new Promise((resolve,reject)=>{
      canvas.toBlob(blob=>blob?resolve(blob):reject(new Error('image_encode_failed')),'image/jpeg',quality);
    });

    const optimisePhoto=async file=>{
      if(!file||!allowedTypes.includes(file.type))throw new Error('unsupported_type');
      if(file.size<=targetBytes&&file.type==='image/jpeg')return file;

      const image=await loadImage(file);
      const longest=Math.max(image.naturalWidth,image.naturalHeight);
      let scale=Math.min(1,maxDimension/longest);
      let width=Math.max(1,Math.round(image.naturalWidth*scale));
      let height=Math.max(1,Math.round(image.naturalHeight*scale));
      const canvas=document.createElement('canvas');
      const context=canvas.getContext('2d',{alpha:false});
      if(!context)throw new Error('canvas_failed');

      const draw=()=>{
        canvas.width=width;
        canvas.height=height;
        context.fillStyle='#fff';
        context.fillRect(0,0,width,height);
        context.imageSmoothingEnabled=true;
        context.imageSmoothingQuality='high';
        context.drawImage(image,0,0,width,height);
      };

      draw();
      let quality=.88;
      let blob=await canvasBlob(canvas,quality);

      while(blob.size>targetBytes&&quality>.58){
        quality-=.06;
        blob=await canvasBlob(canvas,quality);
      }

      while(blob.size>targetBytes&&Math.max(width,height)>1200){
        width=Math.max(1,Math.round(width*.88));
        height=Math.max(1,Math.round(height*.88));
        draw();
        blob=await canvasBlob(canvas,.72);
      }

      const base=(file.name||'photo').replace(/\.[^.]+$/,'');
      return new File([blob],base+'.jpg',{type:'image/jpeg',lastModified:Date.now()});
    };

    const validSelection=()=>{
      if(inputs.some(input=>!input.files||!input.files[0]))return false;
      return inputs.every(input=>allowedTypes.includes(input.files[0].type));
    };

    inputs.forEach(input=>input.addEventListener('change',()=>{
      const preview=input.parentElement.querySelector('img');
      if(preview.dataset.url)URL.revokeObjectURL(preview.dataset.url);
      const file=input.files&&input.files[0];
      preview.hidden=true;

      if(file&&allowedTypes.includes(file.type)){
        preview.dataset.url=URL.createObjectURL(file);
        preview.src=preview.dataset.url;
        preview.hidden=false;
        error.hidden=true;
      }else if(file){
        showError('Please use JPG, PNG or WEBP photos.');
      }
    }));

    form.addEventListener('submit',async event=>{
      if(form.dataset.tcSubmitting==='true')return;
      event.preventDefault();

      if(!form.checkValidity()){
        form.reportValidity();
        return;
      }

      if(!validSelection()){
        showError('Please add all 13 photos using JPG, PNG or WEBP files.');
        return;
      }

      error.hidden=true;
      button.disabled=true;
      progress.hidden=false;

      try{
        let total=0;

        for(let index=0;index<inputs.length;index++){
          progress.textContent='Preparing photo '+(index+1)+' of '+inputs.length+'…';
          const optimised=await optimisePhoto(inputs[index].files[0]);
          total+=optimised.size;

          if(typeof DataTransfer==='undefined')throw new Error('file_replace_unsupported');
          const transfer=new DataTransfer();
          transfer.items.add(optimised);
          inputs[index].files=transfer.files;
        }

        if(total>maxTotalBytes)throw new Error('total_too_large');

        progress.textContent='Adding your personalised frame to the basket…';
        form.dataset.tcSubmitting='true';
        HTMLFormElement.prototype.submit.call(form);
      }catch(uploadError){
        form.dataset.tcSubmitting='false';
        button.disabled=false;
        progress.hidden=true;
        showError('We couldn’t prepare one of your photos for upload. Please try again with JPG, PNG or WEBP photos.');
      }
    });

    window.addEventListener('pageshow',()=>{
      form.dataset.tcSubmitting='false';
      button.disabled=!form.querySelector('option:not([disabled])');
      progress.hidden=true;
    });
  });
}
initialiseTenderForms();
document.addEventListener('shopify:section:load',initialiseTenderForms);
function initialiseTenderGallery() {
  document.querySelectorAll('[data-tc-product]').forEach(root => {
    if (root.dataset.galleryReady) return;
    root.dataset.galleryReady = 'true';
    const select = root.querySelector('select[name="id"]');
    const pictures = [...root.querySelectorAll('[data-tc-gallery-image]')];
    const thumbnails = [...root.querySelectorAll('[data-tc-thumb]')];
    const colours = [...root.querySelectorAll('[data-tc-colour]')];
    const status = root.querySelector('[data-tc-colour-status]');
    if (!select || !pictures.length) return;
    const stage = root.querySelector('.tc-gallery-stage');
    const previous = root.querySelector('[data-tc-previous]');
    const next = root.querySelector('[data-tc-next]');
    const count = root.querySelector('[data-tc-count]');
    let activeIndex = 0;
    const updateControls = () => {
      activeIndex = pictures.reduce((best, picture, index) => Math.abs(picture.getBoundingClientRect().left - stage.getBoundingClientRect().left) < Math.abs(pictures[best].getBoundingClientRect().left - stage.getBoundingClientRect().left) ? index : best, 0);
      thumbnails.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.tcThumb === pictures[activeIndex].dataset.tcGalleryImage)));
      count.textContent = (activeIndex + 1) + ' / ' + pictures.length;
      previous.disabled = activeIndex === 0;
      next.disabled = activeIndex === pictures.length - 1;
    };
    const showImage = id => {
      const picture = pictures.find(picture => picture.dataset.tcGalleryImage === id);
      if (!picture) return;
      stage.scrollTo({left: stage.scrollLeft + picture.getBoundingClientRect().left - stage.getBoundingClientRect().left, behavior: 'instant'});
      updateControls();
    };
    previous.addEventListener('click', () => showImage(pictures[Math.max(0, activeIndex - 1)].dataset.tcGalleryImage));
    next.addEventListener('click', () => showImage(pictures[Math.min(pictures.length - 1, activeIndex + 1)].dataset.tcGalleryImage));
    stage.addEventListener('scroll', updateControls, {passive:true});
    stage.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        (event.key === 'ArrowRight' ? next : previous).click();
      }
    });
    new ResizeObserver(() => showImage(pictures[activeIndex].dataset.tcGalleryImage)).observe(stage);
    const syncColour = () => {
      const option = select.selectedOptions[0];
      if (!option) return;
      showImage(option.dataset.tcImage);
      colours.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.tcColour === select.value)));
      const selected = colours.find(button => button.dataset.tcColour === select.value);
      if (status && selected) status.textContent = selected.querySelector('span').textContent + ' frame — front, side and back';
    };
    select.addEventListener('change', syncColour);
    colours.forEach(button => button.addEventListener('click', () => {
      const option = [...select.options].find(option => option.value === button.dataset.tcColour);
      if (!option) return;
      if (!option.disabled) {
        select.value = option.value;
        select.dispatchEvent(new Event('change', {bubbles: true}));
      } else {
        showImage(button.dataset.tcImage);
        if (status) status.textContent = button.querySelector('span').textContent + ' frame preview — currently unavailable';
      }
    }));
    thumbnails.forEach(button => button.addEventListener('click', () => showImage(button.dataset.tcThumb)));
    window.addEventListener('pageshow', syncColour);
    syncColour();
  });
}
initialiseTenderGallery();
document.addEventListener('shopify:section:load', initialiseTenderGallery);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tender-photo-collage"] && !Shopify.designMode) return;
  try {
    
function initialiseTenderForms() {
  document.querySelectorAll('[data-tc-product]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('form');
    const inputs = [...root.querySelectorAll('[data-tc-photo]')];
    const error = root.querySelector('[data-tc-error]');
    const button = form.querySelector('button[type="submit"]');
    const progress = root.querySelector('[data-tc-progress]');
    const messages = JSON.parse(root.querySelector('[data-upload-messages]').textContent);
    const prepared = new Map();
    const versions = new Map();
    const accepted = ['image/jpeg', 'image/png', 'image/webp'];
    let queue = Promise.resolve();
    let pending = 0;
    let submitting = false;
    let leaving = false;
    const showError = text => { error.textContent = text; error.hidden = false; };
    const fileType = file => file.type || ({jpg:'image/jpeg',jpeg:'image/jpeg',png:'image/png',webp:'image/webp'}[file.name.split('.').pop().toLowerCase()] || '');
    const blobFromCanvas = (canvas, quality) => new Promise((resolve, reject) => canvas.toBlob(blob => blob ? resolve(blob) : reject(new Error('decode')), 'image/jpeg', quality));
    const decode = async file => {
      if (typeof createImageBitmap === 'function') {
        try { return await createImageBitmap(file); } catch (e) {}
      }
      return new Promise((resolve, reject) => {
        const url = URL.createObjectURL(file);
        const image = new Image();
        image.onload = () => { URL.revokeObjectURL(url); resolve(image); };
        image.onerror = () => { URL.revokeObjectURL(url); reject(new Error('decode')); };
        image.src = url;
      });
    };
    const optimise = async file => {
      if (file.size > 25 * 1024 * 1024 || !accepted.includes(fileType(file))) throw new Error('invalid');
      const image = await decode(file);
      const width = image.naturalWidth || image.width;
      const height = image.naturalHeight || image.height;
      if (!width || !height) throw new Error('decode');
      const scale = Math.min(1, 1800 / Math.max(width,height));
      const canvas = document.createElement('canvas');
      canvas.width = Math.max(1, Math.round(width * scale));
      canvas.height = Math.max(1, Math.round(height * scale));
      const context = canvas.getContext('2d', {alpha:false});
      if (!context) { if (image.close) image.close(); throw new Error('decode'); }
      let blob;
      let previewBlob;
      try {
        context.fillStyle = '#fff';
        context.fillRect(0,0,canvas.width,canvas.height);
        context.drawImage(image,0,0,canvas.width,canvas.height);
        for (const quality of [.88,.78,.68,.58]) {
          blob = await blobFromCanvas(canvas,quality);
          if (blob.size <= 450 * 1024) break;
        }
        if (blob.size > 450 * 1024) throw new Error('total');
        const thumb = document.createElement('canvas');
        const ratio = 160 / Math.max(canvas.width,canvas.height);
        thumb.width = Math.max(1,Math.round(canvas.width*ratio));
        thumb.height = Math.max(1,Math.round(canvas.height*ratio));
        thumb.getContext('2d').drawImage(canvas,0,0,thumb.width,thumb.height);
        previewBlob = await blobFromCanvas(thumb,.75);
        thumb.width = thumb.height = 1;
      } finally {
        if (image.close) image.close();
        canvas.width = canvas.height = 1;
      }
      return {file:new File([blob], 'photo.jpg', {type:'image/jpeg'}),preview:previewBlob};
    };
    inputs.forEach(input => input.addEventListener('change', () => {
      const version = (versions.get(input) || 0) + 1;
      versions.set(input,version);
      prepared.delete(input);
      input.setCustomValidity('');
      const preview = input.parentElement.querySelector('img');
      const status = input.parentElement.querySelector('[data-file-status]');
      if (preview.dataset.url) URL.revokeObjectURL(preview.dataset.url);
      preview.removeAttribute('src');
      preview.hidden = true;
      const file = input.files && input.files[0];
      status.textContent = '';
      status.dataset.state = '';
      if (!file) return;
      pending++;
      status.textContent = messages.preparing;
      error.hidden = true;
      queue = queue.then(async () => {
        if (versions.get(input) !== version) return;
        try {
          const result = await optimise(file);
          if (versions.get(input) !== version) return;
          prepared.set(input,result.file);
          preview.dataset.url = URL.createObjectURL(result.preview);
          preview.src = preview.dataset.url;
          preview.hidden = false;
          status.textContent = messages.ready;
          status.dataset.state = 'ready';
        } catch (e) {
          if (versions.get(input) !== version) return;
          const message = messages[e.message] || messages.decode;
          status.textContent = message;
          status.dataset.state = 'error';
          input.setCustomValidity(message);
          showError(message);
        }
      }).catch(() => showError(messages.decode)).finally(() => { pending--; });
    }));
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (submitting) return;
      if (pending) { showError(messages.busy); return; }
      if (!form.reportValidity()) return;
      if (prepared.size !== inputs.length) { showError(messages.missing); return; }
      const bytes = [...prepared.values()].reduce((sum,file) => sum+file.size,0);
      if (bytes > 6 * 1024 * 1024) { showError(messages.total); return; }
      submitting = true;
      button.disabled = true;
      error.hidden = true;
      progress.hidden = false;
      progress.textContent = messages.uploading;
      const fields = new FormData(form);
      fields.delete('return_to');
      inputs.forEach((input,index) => fields.set(input.name,prepared.get(input),'photo-'+(index+1)+'.jpg'));
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(),120000);
      try {
        const base = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        const response = await fetch(base+'cart/add.js', {method:'POST',body:fields,signal:controller.signal,headers:{Accept:'application/json'}});
        if (!response.ok) throw new Error('rejected');
        await response.json();
        leaving = true;
        window.location.assign(base+'cart');
      } catch (e) {
        showError(e.message === 'rejected' ? messages.rejected : messages.failed);
      } finally {
        clearTimeout(timer);
        if (!leaving) {
          submitting = false;
          button.disabled = false;
          progress.hidden = true;
        }
      }
    });
    window.addEventListener('pageshow', () => {
      submitting = false;
      leaving = false;
      button.disabled = !form.querySelector('option:not([disabled])');
      progress.hidden = true;
    });
  });
}
initialiseTenderForms();
document.addEventListener('shopify:section:load',initialiseTenderForms);

function initialiseTenderGallery() {
  document.querySelectorAll('[data-tc-product]').forEach(root => {
    if (root.dataset.galleryReady) return;
    root.dataset.galleryReady = 'true';
    const select = root.querySelector('select[name="id"]');
    const pictures = [...root.querySelectorAll('[data-tc-gallery-image]')];
    const thumbnails = [...root.querySelectorAll('[data-tc-thumb]')];
    const colours = [...root.querySelectorAll('[data-tc-colour]')];
    const status = root.querySelector('[data-tc-colour-status]');
    if (!select || !pictures.length) return;
    const stage = root.querySelector('.tc-gallery-stage');
    const previous = root.querySelector('[data-tc-previous]');
    const next = root.querySelector('[data-tc-next]');
    const count = root.querySelector('[data-tc-count]');
    let activeIndex = 0;
    const updateControls = () => {
      activeIndex = pictures.reduce((best, picture, index) => Math.abs(picture.getBoundingClientRect().left - stage.getBoundingClientRect().left) < Math.abs(pictures[best].getBoundingClientRect().left - stage.getBoundingClientRect().left) ? index : best, 0);
      thumbnails.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.tcThumb === pictures[activeIndex].dataset.tcGalleryImage)));
      count.textContent = (activeIndex + 1) + ' / ' + pictures.length;
      previous.disabled = activeIndex === 0;
      next.disabled = activeIndex === pictures.length - 1;
    };
    const showImage = id => {
      const picture = pictures.find(picture => picture.dataset.tcGalleryImage === id);
      if (!picture) return;
      stage.scrollTo({left: stage.scrollLeft + picture.getBoundingClientRect().left - stage.getBoundingClientRect().left, behavior: 'instant'});
      updateControls();
    };
    previous.addEventListener('click', () => showImage(pictures[Math.max(0, activeIndex - 1)].dataset.tcGalleryImage));
    next.addEventListener('click', () => showImage(pictures[Math.min(pictures.length - 1, activeIndex + 1)].dataset.tcGalleryImage));
    stage.addEventListener('scroll', updateControls, {passive:true});
    stage.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        (event.key === 'ArrowRight' ? next : previous).click();
      }
    });
    new ResizeObserver(() => showImage(pictures[activeIndex].dataset.tcGalleryImage)).observe(stage);
    const syncColour = () => {
      const option = select.selectedOptions[0];
      if (!option) return;
      showImage(option.dataset.tcImage);
      colours.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.tcColour === select.value)));
      const selected = colours.find(button => button.dataset.tcColour === select.value);
      if (status && selected) status.textContent = selected.querySelector('span').textContent + ' frame';
    };
    select.addEventListener('change', syncColour);
    colours.forEach(button => button.addEventListener('click', () => {
      const option = [...select.options].find(option => option.value === button.dataset.tcColour);
      if (!option) return;
      if (!option.disabled) {
        select.value = option.value;
        select.dispatchEvent(new Event('change', {bubbles: true}));
      } else {
        showImage(button.dataset.tcImage);
        if (status) status.textContent = button.querySelector('span').textContent + ' frame preview — currently unavailable';
      }
    }));
    thumbnails.forEach(button => button.addEventListener('click', () => showImage(button.dataset.tcThumb)));
    window.addEventListener('pageshow', syncColour);
    syncColour();
  });
}
initialiseTenderGallery();
document.addEventListener('shopify:section:load', initialiseTenderGallery);


  } catch(e) { console.error(e); }
})();
})();
